export default "__VITE_ASSET__Cotpumd$__"